export var BackgroundStyle = {
  default: 'transparent',
  white: 'neutral.white',
  lightest: 'neutral.lightest'
};
//# sourceMappingURL=layout.theme.utils.js.map